export enum Locale {
    EnAu = 'en-AU',
}
